
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// const sysInfo = {
//   apiRemote: 'http://47.111.75.34:8080/app/mock/22'
// }

export function insertPurchases (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/purchase',
    method: 'POST',
    data: parameter
  })
}
export function updatePurchases (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/purchases',
    method: 'PUT',
    data: parameter
  })
}
export function deletePurchases (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/purchase',
    method: 'DELETE',
    params: parameter
  })
}
export function getPurchasesList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/purchases',
    method: 'GET',
    params: parameter
  })
}
export function getPurchasesInfo (parameter) {
return axios({
    url: sysInfo.apiRemote + `/contract/purchase/detail?id=${parameter}`,
    method: 'GET'
  })
}
